// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"935d6537","323":"8ee4a392"}[chunkId] + ".chunk.js";
};